import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { HeaderComponent } from './header/header.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { HomeComponent } from './home/home.component';
import { HowChooseColorComponent } from './how-choose-color/how-choose-color.component';
import { FooterComponent } from './footer/footer.component';
import { StartProjectComponent } from './start-project/start-project.component';
import { ChooseProjectComponent } from './choose-project/choose-project.component';
import { PalettesInfoComponent } from './palettes-info/palettes-info.component';
import { ChoosePaletteComponent } from './choose-palette/choose-palette.component';
import { ComposeColorSetComponent } from './compose-color-set/compose-color-set.component';
import { WhatPlasterComponent } from './what-plaster/what-plaster.component';
import { Questionnaire1Component } from './questionnaire1/questionnaire1.component';
import { Questionnaire2Component } from './questionnaire2/questionnaire2.component';
import { Questionnaire3Component } from './questionnaire3/questionnaire3.component';
import { QuestionnaireSummaryComponent } from './questionnaire-summary/questionnaire-summary.component';
import { Questionnaire4Component } from './questionnaire4/questionnaire4.component';
import { FinishedProjectComponent } from './finished-project/finished-project.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { WhereBuyComponent } from './where-buy/where-buy.component';
// import { AgmCoreModule } from '@agm/core';
import { ProjectSummaryComponent } from './project-summary/project-summary.component';
import { PrintProjectSummaryComponent } from './print-project-summary/print-project-summary.component';
import { SelectMosaicComponent } from './select-mosaic/select-mosaic.component';
import { PalettePipe } from './palette.pipe';
import { PlasterTypePipe } from './plaster-type.pipe';
import { IzolacjaPipe } from './izolacja.pipe';
import { LokalizacjaPipe } from './lokalizacja.pipe';
import { FakturaPipe } from './faktura.pipe';
import { GramaturaPipe } from './gramatura.pipe';
import { GeocodeService } from './geocode.service';
import { ModalComponent } from './modal/modal.component';
import { MyProjectsComponent } from './my-projects/my-projects.component';
import { HelpComponent } from './help/help.component';
import { EditorComponent } from './editor/editor.component';
import { UserStartProjectComponent } from './user-start-project/user-start-project.component';
// import { DeviceDetectorModule } from 'ngx-device-detector';
import { DragDropDirective } from './drag-drop.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { MDBBootstrapModule } from 'angular-bootstrap-md';
// import { MDBSpinningPreloader, MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import {MatAccordion, MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import { GoogleMapsModule, MapAdvancedMarker, MapInfoWindow } from "@angular/google-maps";

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HeaderComponent,
    MainHeaderComponent,
    HomeComponent,
    HowChooseColorComponent,
    FooterComponent,
    StartProjectComponent,
    ChooseProjectComponent,
    PalettesInfoComponent,
    ChoosePaletteComponent,
    ComposeColorSetComponent,
    WhatPlasterComponent,
    Questionnaire1Component,
    Questionnaire2Component,
    Questionnaire3Component,
    QuestionnaireSummaryComponent,
    Questionnaire4Component,
    FinishedProjectComponent,
    CalculatorComponent,
    WhereBuyComponent,
    ProjectSummaryComponent,
    PrintProjectSummaryComponent,
    SelectMosaicComponent,
    PalettePipe,
    PlasterTypePipe,
    IzolacjaPipe,
    LokalizacjaPipe,
    FakturaPipe,
    GramaturaPipe,
    ModalComponent,
    MyProjectsComponent,
    HelpComponent,
    EditorComponent,
    UserStartProjectComponent,
    DragDropDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    FontAwesomeModule,
    MatIconModule,
    MatExpansionModule,
    GoogleMapsModule,
    MapAdvancedMarker,
    MatTooltipModule,
    // ToastModule.forRoot(),
    // MDBBootstrapModulesPro.forRoot(),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyAMZRpD73Uk95x1sOo-NYNVmFdInLoC1fQ',
    //   language: "PL"
    // }),
    // DeviceDetectorModule.forRoot(),
    // MDBBootstrapModule.forRoot()
  ],
  providers: [GeocodeService],
  bootstrap: [AppComponent]
})
export class AppModule { }
